@if (vm$ | async; as vm) {
  <!-- App Header - Fixed top bar -->
  <app-header
    [logoUrl]="logoUrl"
    [userName]="vm.loginUserName ?? ''"
    [userRole]="vm.loginUserJob ?? 'スタッフ'"
    [showHamburger]="true"
    [showHelp]="false"
    [showFaq]="true"
    [sidenavCollapsed]="isSidenavCollapsed()"
    (hamburgerClick)="toggleSelf()"
    (logoutClick)="logout()"
    (themeToggle)="toggleTheme()">
    <!-- Workspace selector in header (mat-select) -->
    <mat-select workspaceSelector
                #sectionSelect
                class="section-select"
                [class.section-select--expanded]="isSectionSelectExpanded"
                [value]="vm.selectedSection"
                [compareWith]="compareSections"
                (selectionChange)="onSectionChange($event)"
                (mousedown)="onSectionSelectMousedown($event)"
                (closed)="onSectionSelectClosed()"
                panelClass="section-select-panel"
                [hideSingleSelectionIndicator]="false">
      <mat-select-trigger>
        <div class="section-select__trigger" (pointerdown)="onTriggerPointerDown($event)">
          <mat-icon class="trigger-icon" fontSet="material-icons-outlined">domain</mat-icon>
          <span class="trigger-name">{{ vm.selectedSection?.sectionName }}</span>
          <mat-icon class="trigger-arrow">arrow_drop_down</mat-icon>
        </div>
      </mat-select-trigger>
      @for (section of vm.sections; track trackSectionById($index, section)) {
        <mat-option [value]="section">
          {{ section.sectionName }}
        </mat-option>
      }
    </mat-select>
    <!-- Profile menu items -->
    @if ((vm.systemAdminRole || vm.distributorAgentRole) && vm.contractEnabled) {
      <button profileMenuItems mat-menu-item (click)="openNewWindow('/system-admin/section-groups')">
        <mat-icon fontSet="material-icons-outlined">admin_panel_settings</mat-icon>
        <span i18n="@@home.homeNav.menu.systemAdmin">システム管理</span>
      </button>
    }
    @if (administeredSectionGroupId) {
      <button profileMenuItems mat-menu-item (click)="openNewWindow('/section-group-admin/' + (administeredSectionGroupId ?? '') + '/home')">
        <mat-icon fontSet="material-icons-outlined">corporate_fare</mat-icon>
        <span i18n="@@home.homeNav.menu.sectionGroupAdmin">グループ管理</span>
      </button>
    }
    @if ((vm.accountManagementRole || vm.userManagementRole) && vm.contractEnabled) {
      <button profileMenuItems mat-menu-item (click)="openNewWindow('/section-admin/' + (vm.selectedSection?.sectionId ?? ''))">
        <mat-icon fontSet="material-icons-outlined">badge</mat-icon>
        <span i18n="@@home.homeNav.menu.staffMenu">スタッフメニュー</span>
      </button>
    }
  </app-header>

  <mat-sidenav-container class="mat-sidenav-container" [class.sidenav-collapsed]="isSidenavCollapsed()" autosize>
    <mat-sidenav #drawer class="mat-sidenav" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async) && isNavSystemOpen">

      <div class="sidenav">
        <div class="sidenav-main">
          @if ((vm.recordMeasurerRole || vm.recordRefererRole) && vm.contractEnabled) {
            <div class="sidenav-content-panel" [class.quick-action-active]="activeQuickActionId()">
              <!-- Quick Actions -->
              @if (vm.userManagementRole || vm.accountManagementRole) {
                <div class="sidenav-section">
                  <h3 class="sidenav-section__title" i18n="@@home.homeNav.title.quickActions">クイックアクション</h3>
                  <div class="sidenav-menu-items">
                    @if (vm.userManagementRole) {
                      <div class="side_menu_item">
                        <a class="link" [class.selected]="activeQuickActionId() === 'createUser'" (click)="navigateToCreateUser()">
                          <mat-icon aria-hidden="true" fontSet="material-icons-outlined">person_add</mat-icon>
                          <span>{{ quickActionCreateUserLabel }}</span>
                        </a>
                      </div>
                    }
                    @if (vm.accountManagementRole) {
                      <div class="side_menu_item">
                        <a class="link" [class.selected]="activeQuickActionId() === 'inviteStaff'" (click)="navigateToInvite()">
                          <mat-icon aria-hidden="true" fontSet="material-icons-outlined">send</mat-icon>
                          <span>{{ quickActionInviteStaffLabel }}</span>
                        </a>
                      </div>
                    }
                  </div>
                </div>
              }
              <!-- Menu -->
              <div class="sidenav-section">
                <h3 class="sidenav-section__title" i18n="@@home.homeNav.title.menu">メニュー</h3>
                <div class="sidenav-menu-items">
                <div class="side_menu_item user-top"
                     cdkOverlayOrigin
                     #usersMenuTrigger="cdkOverlayOrigin"
                     (mouseenter)="onUsersMenuMouseEnter()"
                     (mouseleave)="onUsersMenuMouseLeave()"
                     (click)="onUsersMenuClick($event)">
                  <a class="link" [routerLink]="['users']" routerLinkActive="selected">
                    <mat-icon aria-hidden="true" fontSet="material-icons-outlined">face</mat-icon>
                    <span i18n="@@home.homeNav.menu.userList">ユーザー</span>
                  </a>
                </div>

                <!-- User Quick Switch Popover (appears on hover when on user detail page) -->
                <ng-template cdkConnectedOverlay
                             [cdkConnectedOverlayOrigin]="usersMenuTrigger"
                             [cdkConnectedOverlayOpen]="isUserPopoverOpen()"
                             [cdkConnectedOverlayPanelClass]="'quick-switch-overlay-pane'"
                             [cdkConnectedOverlayPositions]="[
                               { originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'top', offsetX: 8, offsetY: -45 },
                               { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 8, offsetY: -20 }
                             ]"
                             [cdkConnectedOverlayHasBackdrop]="false">
                  <app-user-quick-switch-popover
                    [users]="cachedUsersForSection()"
                    [currentUserId]="userDetailContext.activeUserId()"
                    (userSelected)="onPopoverUserSelected($event)"
                    (mouseEnter)="onUserPopoverMouseEnter()"
                    (mouseLeave)="onUserPopoverMouseLeave()" />
                </ng-template>
                @if (vm.showTomassMenu) {
                  <div class="side_menu_item tomass-summary">
                    <a class="link" [routerLink]="['tomass-summary']" routerLinkActive="selected">
                      <mat-icon aria-hidden="true" fontSet="material-icons-outlined">assessment</mat-icon>
                      <span i18n="@@home.homeNav.menu.tomassSummary">TOMASSサマリー</span>
                    </a>
                  </div>
                }
                @if (vm.showMentionMenu) {
                  <app-mention-menu-item inner_div_class="side_menu_item mention-top">
                    <a class="link" [routerLink]="['mentions']" routerLinkActive="selected">
                      <mat-icon aria-hidden="true" fontSet="material-icons-outlined">chat</mat-icon>
                      <span i18n="@@home.homeNav.menu.mentionList">メンション一覧</span>
                    </a>
                  </app-mention-menu-item>
                }
                </div>
              </div>
              <!-- Recent Users (hidden when collapsed) -->
              @if (!isSidenavCollapsed()) {
                <div class="sidenav-section sidenav-section--recent-users">
                  <h3 class="sidenav-section__title" i18n="@@home.homeNav.title.recentUsers">最近のユーザー</h3>
                  <div class="sidenav-recent-users">
                    @if (recentUsersForSection().length > 0) {
                      <div class="recent-users-list">
                        @for (user of recentUsersForSection(); track user.id) {
                          <button mat-button (click)="navigateToRecentUser(user)" class="recent-user-item">
                            <span class="user-avatar"
                                  [class.avatar-male]="user.sex === 'male'"
                                  [class.avatar-female]="user.sex === 'female'">
                              {{ getInitials(user.name) }}
                            </span>
                            <span class="user-name">{{ user.name }}</span>
                          </button>
                        }
                      </div>
                    } @else {
                      <p class="recent-users-empty" i18n="@@home.homeNav.message.noRecentUsers">最近アクセスしたユーザーはいません</p>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <!-- Footer (hidden when collapsed) -->
        @if (!isSidenavCollapsed()) {
          <div class="sidenav-footer">
            <span class="sidenav-footer__text">© {{ year }} PLIMES Inc.</span>
          </div>
        }
      </div>
    </mat-sidenav>

  <mat-sidenav-content class="mat-sidenav-content"
                       [class.has-secondary-panel]="showSecondaryPanelLayout()">
    <!-- Secondary Panel (Quick Actions only) -->
    @if (isSecondaryPanelOpen()) {
      <div class="secondary-panel secondary-panel--open secondary-panel--quick-action"
           [style.width]="secondaryPanelWidth()">
        <app-right-drawer-content></app-right-drawer-content>
      </div>
    }

    <!-- Main content area -->
    <div class="main-content-area">
      @if (vm.status === 'error' && vm.errorMessage) {
        <div class="error-banner">
          <div class="error-banner__message"> {{ vm.errorMessage }} </div>
        </div>
      }
      @if (vm.isSectionLoading || vm.contractEnabled || isErrorRoute()) {
        <!-- Content display: child components handle their own loading skeletons -->
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      } @else {
        <!-- Contract expired (CLOSE) state -->
        <div class="spinner-container">
          <mat-spinner diameter="48" />
        </div>
      }

    </div>
  </mat-sidenav-content>
  </mat-sidenav-container>
}
